export default __webpack_public_path__ + "static/media/close.a0b2e910.png";